import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { EducationCatalog } from '@/components/education/EducationCatalog';
import Header from '@/components/navigation/Header';
import Footer from '@/components/sections/Footer';

const Education: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" state={{ from: { pathname: '/education' } }} replace />;
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 py-8 pt-24">
        <div className="mb-8">
          <h1 className="text-4xl font-bold mb-4">Bitcoin Education</h1>
          <p className="text-xl text-muted-foreground">
            Master Bitcoin with our comprehensive course system. Learn at your own pace, 
            track your progress, and earn certificates.
          </p>
        </div>
        <EducationCatalog />
      </main>
      <Footer />
    </div>
  );
};

export default Education;